import { of } from 'rxjs';
import { extractValueFromParams } from '@awp/core/utils';
import * as i0 from "@angular/core";
var ThemeResolver = /** @class */ (function () {
    function ThemeResolver() {
    }
    ThemeResolver.prototype.resolve = function (route, state) {
        var themeId = extractValueFromParams(route, 'themeId');
        return of({ themeId: themeId });
    };
    ThemeResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeResolver_Factory() { return new ThemeResolver(); }, token: ThemeResolver, providedIn: "root" });
    return ThemeResolver;
}());
export { ThemeResolver };
